import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../lib/api";
import ApplicationWizard from "./ApplicationWizard";
import InternApplicationWizard from "./InternApplicationWizard";

export default function ApplyRouter() {
  const { slug } = useParams();
  const [job, setJob] = useState(null);

  useEffect(() => {
    api.get(`/jobs/${slug}`).then(({ data }) => setJob(data)).catch(() => setJob(false));
  }, [slug]);

  if (job === null) return <div className="min-h-screen grid place-items-center bg-[#F7F0E2] text-muted-foreground" data-testid="apply-loading">Loading application…</div>;
  if (job === false) return <div className="min-h-screen grid place-items-center bg-[#F7F0E2] text-muted-foreground" data-testid="apply-not-found">Role not found.</div>;

  if (job.application_type === "internship") return <InternApplicationWizard job={job} />;
  return <ApplicationWizard job={job} />;
}
